import React, { useEffect, useRef } from 'react';
import Header from '../header';
import LandingImage from './components/landingImage';
// // import Procedure from './components/procedure';
import PourquoiSimulation from './components/pourquoiSimulation';
import Footer from '../footer';
// import { useDispatch } from 'react-redux';
// import { setConfig } from '../../store/configSlice';
// import getEnvironement from '../../environnement';
// import axios from 'axios';
import Actualites from './components/actualites/actualites';
import InscriptionAtelierForms from './components/actualites/firstworldcup/inscriptionAtelierForm';
// import { ToastContainer } from 'react-toastify';

export default function Landing({
  activeItem
}) {
  const eventFormDiv = useRef(null);
  // const dispatch = useDispatch();

  // const setConfigData = useCallback(async () => {
  //   const url = `${getEnvironement().API_URL}/config`;
  //   await axios.post(url)
  //     .then((res) => dispatch(setConfig(res.data)))
  // }, [dispatch]);

  // useEffect(() => {
  //   setConfigData();
  // }, [setConfigData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToEventFormDiv = () => {
    eventFormDiv.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
    <div className='flex flex-col h-screen'>
      <Header activeItem={activeItem}/>
      <LandingImage onClickScrollIcon={scrollToEventFormDiv} />
      <Actualites />
      <InscriptionAtelierForms eventFormDiv={eventFormDiv}/>
      {/* <Procedure procedureDiv={procedureDiv}/> */}
      <PourquoiSimulation />
      <Footer />
    </div>
    </>
  );
}
